import { Pipe, PipeTransform } from '@angular/core';
import { ICONS } from '@nimbus-library/features/shared/resources/icons';
import { IInputAssignRoleOU } from './i-input-assign-role';

@Pipe({
  name: 'toTag',
  standalone: false,
})
export class OrganizationUnitToTagPipe implements PipeTransform {
  public transform(value: IInputAssignRoleOU[], ...args: any[]): any {
    return value.map((x) => ({
      name: x.name,
      postFix: x.kind === 'Team' ? ICONS.USERS : null,
    }));
  }
}
